import React, { useState, useRef, useEffect } from "react";
import manuscriptImage from '../Img/manuscript_img.png';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ProcessingFeesForm = () => {
  const login = JSON.parse(localStorage.getItem("isLoggedIn")) || "";
  const [referenceNumbers, setReferenceNumbers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [plan, setPlans] = useState([])


  const [formData, setFormData] = useState({
    name: login.name || "",
    email: login.email || "",
    phone: login.mobile || "",
    country: login.country || "",
    address: login.address,
    user_id: login.id,
    manuscriptNumber: "",
    selectedPlan: null,
    fee: null,
    iscouponapplied: null,
    coupon: null,
  });


  const [errors, setErrors] = useState({});
  const firstFieldRef = useRef(null);

  const fetchDataPlan = async () => {
    try {
      const response = await fetch(`https://backend.impactjournal.co.in/plan`)
      const res = await response.json();
      const activePlans = res.filter(plan => plan.status === "Active");
      console.log(res);
      setPlans(activePlans);
    } catch (error) {
      console.log(error)
    }
  }
  const [manuscripts, setManuscripts] = useState([]);

  useEffect(() => {
    fetch("https://backend.impactjournal.co.in/manuscript")
      .then((res) => res.json())
      .then((data) => {
        const userManuscripts = data.filter(
          (item) => item.email === login.email && item.pay_status !== "Paid"
        );
        setManuscripts(userManuscripts); // Store full manuscripts
      })
      .catch((err) => {
        console.error("Failed to load manuscript numbers", err);
      });
  }, []);

  const handleManuscriptChange = (e) => {
    const selectedRef = e.target.value;
    const manuscript = manuscripts.find(m => m.referenceNumber === selectedRef);
    if (manuscript) {
      const matchedPlan = plan.find(p => p.article_category === manuscript.articleCategory);
      const fee = matchedPlan?.final_price || 1199;

      setFormData(prev => ({
        ...prev,
        manuscriptNumber: selectedRef,
        selectedPlan: {
          article_category: matchedPlan?.article_category || "Default",
          base_price: matchedPlan?.base_price || "",
          final_price: matchedPlan?.final_price || 1199
        },
        fee: fee
      }));
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Valid email is required";
    if (!formData.phone || !/^\d{12}$/.test(formData.phone)) newErrors.phone = "Valid 10-digit phone number is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.manuscriptNumber) newErrors.manuscriptNumber = "Manuscript number is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const openRazorpay = (razorpayOrder, order_id) => {
    const options = {
      key: "rzp_live_Rkjr9d9h0LQfaV",
      amount: razorpayOrder.amount,
      currency: razorpayOrder.currency,
      name: "Impact",
      description: "Order Payment",
      order_id: razorpayOrder.id,
      handler: async function (response) {
        const verifyRes = await fetch("https://backend.impactjournal.co.in/processingfee/verify", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          }),
        });

        const verifyData = await verifyRes.json();
        if (verifyData.success) {
          window.location.href = `/payment-success/${order_id}`; // ✅ Redirect on success
        } else {
          window.location.href = `/payment-failed/${order_id}`; // ❌ Redirect on failure
        }
      },
      prefill: {
        name: "Impact",
        email: "support@accormed.in",
        contact: "9326623800",
      },
      theme: { color: "#d1060c" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true); // Show spinner

    try {
      const response = await fetch("https://backend.impactjournal.co.in/processingfee", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      openRazorpay(data.razorpay_order, data.order_id);
      if (response.ok) {
        toast.success("Submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          country: "",
          address: "",
          manuscriptNumber: "",
        });
      } else {
        alert("Submission failed: " + data.message);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("An error occurred while submitting.");
    } finally {
      setLoading(false); // Hide spinner
    }
  };
  const handleApplyCoupon = async () => {
    if (!formData.coupon || !formData.manuscriptNumber) {
      toast.error("Please enter a coupon and select a manuscript.");
      return;
    }

    try {
      const res = await fetch(`https://backend.impactjournal.co.in/coupon/check/${formData.coupon}`);
      console.log(res);
      const result = await res.json();
      const data = result.couponData
      // if (!res.ok || !data.success) {
      //   toast.error(data.message || "Invalid or expired coupon.");
      //   return;
      // }
      if (res.status === 400) {
        toast.error(result.message || "Invalid or expired coupon.");
        return;
      }

      const originalFee = formData?.fee || 1199;
      let discountedFee = originalFee;

      if (data.percentage_offer) {
        discountedFee = Math.round(originalFee - (originalFee * data.percentage_offer / 100));
      } else if (data.price_offer) {
        discountedFee = Math.max(0, originalFee - data.price_offer);
      }

      setFormData((prev) => ({
        ...prev,
        fee: discountedFee,
        iscouponapplied: true,
        coupon: formData.coupon
      }));

      toast.success("Coupon applied successfully!");
    } catch (err) {
      console.error("Coupon apply error:", err);
      toast.error("Failed to apply coupon.");
    }
  };


  const renderError = (field) =>
    errors[field] && <div className="form-register-error-impact">{errors[field]}</div>;

  useEffect(() => {
    fetchDataPlan();
  }, [])
  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
      <div className="register-main-pm manuscript-main-pm">
        <div className="manuscript-img-div-pm">
          <img src={manuscriptImage} alt="Processing Illustration" />
        </div>

        <div className="register-section-pm manuscript-top-pm">
          <div className="form-register-wrapper-impact">
            <h2>Processing Fees</h2>
            <div className="form-register-step-impact">

              <div className="form-register-input-group-impact">
                <label htmlFor="name" className="form-register-label-impact">Full Name</label>
                <input
                  ref={firstFieldRef}
                  id="name"
                  name="name"
                  placeholder="Enter your full name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("name")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="email" className="form-register-label-impact">Email Address</label>
                <input
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("email")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="phone" className="form-register-label-impact">Phone Number</label>
                <PhoneInput
                  country={'in'}
                  value={formData.phone}
                  onChange={(phone) => setFormData({ ...formData, phone })}
                  inputClass="form-register-input-impact"
                  inputProps={{
                    name: 'phone',
                    required: true,
                    id: 'phone'
                  }}
                />
                {renderError("phone")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="country" className="form-register-label-impact">Country</label>
                <input
                  id="country"
                  name="country"
                  placeholder="Enter your country"
                  value={formData.country}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("country")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="address" className="form-register-label-impact">Address</label>
                <input
                  id="address"
                  name="address"
                  placeholder="Enter your full address"
                  value={formData.address}
                  onChange={handleChange}
                  className="form-register-input-impact"
                />
                {renderError("address")}
              </div>

              <div className="form-register-input-group-impact">
                <label htmlFor="manuscriptNumber" className="form-register-label-impact">Manuscript Number</label>
                <select
                  id="manuscriptNumber"
                  name="manuscriptNumber"
                  value={formData.manuscriptNumber}
                  onChange={handleManuscriptChange}
                  className="form-register-input-impact"
                >
                  <option value="">Select a manuscript</option>
                  {manuscripts.map((m, index) => (
                    <option key={index} value={m.referenceNumber}>
                      {m.referenceNumber} - {m.articleTitle}
                    </option>
                  ))}
                </select>

                {renderError("manuscriptNumber")}
              </div>


              <div className="form-register-input-group-impact">
                <label className="form-register-label-impact">Processing Fee (INR)</label>
                <input
                  type="text"
                  value={`₹${formData.fee || "N/A"}`}
                  readOnly
                  className="form-register-input-impact"
                />

              </div>
              <div className="form-register-input-group-impact" style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  name="coupon"
                  placeholder="Enter coupon code"
                  value={formData.coupon}
                  onChange={handleChange}
                  disabled={formData.iscouponapplied}
                  className="form-register-input-impact"
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  onClick={handleApplyCoupon}
                  disabled={formData.iscouponapplied}
                  className="form-register-btn-impact form-register-btn-submit-impact"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {formData.iscouponapplied ? "Applied" : "Apply"}
                </button>
              </div>

              <div className="form-register-navigation-impact">
                <button
                  onClick={handleSubmit}
                  className="form-register-btn-impact form-register-btn-submit-impact"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner"></span>
                  ) : (
                    "Submit and Pay"
                  )}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcessingFeesForm;
